module.exports = __webpack_public_path__ + "img/menu-rotated.e16d9a5a.svg";